module.exports = __webpack_public_path__ + "static/media/1.Control Panels.f3727f96.jpg";